import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "voiceInput", "status", "button"]

  timeout = null
  recording = false
  recorder = null
  submitted = false // 👈 NEW
  chunks = []
  mediaStream = null

  pressStart(event) {
    event.preventDefault()
    this.submitted = false // reset each interaction

    this.timeout = setTimeout(() => {
      this.startRecording()
    }, 400)
  }

  pressEnd(event) {
    event.preventDefault()

    if (this.timeout) {
      clearTimeout(this.timeout)

      if (!this.recording && !this.submitted) {
        this.submitted = true // ✅ Prevent future triggers
        this.dispatchEncryptSubmit()
      } else if (this.recording) {
        this.stopRecording()
      }
    }
  }

  startRecording() {
    this.statusTarget.textContent = "🎙️---🗿 Recording..."
    this.recording = true

    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        this.mediaStream = stream
        this.recorder = new MediaRecorder(stream)
        this.chunks = []
        this.recorder.ondataavailable = e => this.chunks.push(e.data)
        this.recorder.onstop = this.handleRecordingStop.bind(this)
        this.recorder.start()
      })
      .catch(err => {
        console.error("🎤 Microphone error:", err)
        this.statusTarget.textContent = "🚫 Mic permission denied"
        this.recording = false
      })
  }

  stopRecording() {
    if (!this.recorder) return
    this.statusTarget.textContent = "👄---🍬 Chewing..."
    this.recorder.stop()
    this.mediaStream.getTracks().forEach(track => track.stop())
    this.recording = false
  }

  handleRecordingStop() {
    const blob = new Blob(this.chunks, { type: 'audio/webm' })
    const file = new File([blob], `voice-${Date.now()}.webm`, {
      type: "audio/webm"
    })

    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.voiceInputTarget.files = dataTransfer.files

    setTimeout(() => {
      if (!this.submitted) {
        this.submitted = true
        this.dispatchEncryptSubmit()
      }
    }, 100)
  }

  dispatchEncryptSubmit() {
    this.formTarget.dispatchEvent(new CustomEvent("encrypt-submit:go", {
      bubbles: true
    }))
  }
}
